<div class="approval-status modern">
  <div class="pill" [ngClass]="'pill-' + registrant.entry_status" ngxTippy="Current status">
    <span class="dot"></span>
    <span class="label">{{ statusText }}</span>
  </div>
  <div class="icon-actions">
    <button class="icon-btn approve" *ngIf="statusActions?.length && canChangeApprovalStatus" ngxTippy="Approve" (click)="onApproveClick()" [disabled]="registrant?.entry_status === 4">
      <mat-icon>check_circle</mat-icon>
    </button>
    <button class="icon-btn decline" *ngIf="canChangeApprovalStatus" ngxTippy="Decline" (click)="onDeclineClick()" [disabled]="registrant?.entry_status === 5">
      <mat-icon>cancel</mat-icon>
    </button>
    <button class="icon-btn revision" *ngIf="canChangeApprovalStatus" ngxTippy="Request revision" (click)="onRequestRevisionClick()">
      <mat-icon>edit_note</mat-icon>
    </button>
    <button class="icon-btn history" ngxTippy="Revision history" (click)="openRequestHistory()">
      <mat-icon>history</mat-icon>
    </button>
  </div>
</div>
